{
	"exportCanceledTitle": "Export Canceled",
	"exportCompleteTitle": "Export Complete",
	"exportFailedOfflineMessage": "Export failed because you appear to be offline. {{details}} Please check your internet connection and try again.",
	"exportFailedTitle": "Export Failed",
	"exportIncompleteTitle": "Export Incomplete",
	"failedExportPhoto": "Failed to export photo: {{filename}}",
	"trainMyAiStyle": "Train My AI Style"
}
